import React, { useState } from 'react';
import App from './pages/App';
import Auth from './pages/Auth';
import useAPI  from './hooks/useAPI';
import AppContext from './contexts/AppContext';
import AuthContext from './contexts/AuthContext';
import {BrowserRouter as Router} from 'react-router-dom';

export default function Entry()
{ 
  const api = useAPI();
  const [user, setUser] = useState(api.cookie('user') || null);
  const auth = api.cookie('auth') || null;
  const systems = api.cookie('systems') || [];
  const system = api.cookie('system') || null;

  const [sessionSettings, setSessionSettings] = useState(api.cookie('session_settings') || {menu_closed: false});

  return (
    <AppContext.Provider 
      value={{
          
      }}
    >
      <Router onUpdate={() => window.scrollTo(0, 0)}>
            {
              user && auth ?
                <AuthContext.Provider value={{ 
                  auth,
                  user, 
                  sessionSettings,
                  systems,
                  system, 
                  onUpdateSessionSettings: (updatedSettings)=>{
                    const newSettings = Object.assign(sessionSettings, updatedSettings);
                    setSessionSettings(newSettings);
                    api.setSessionSettings(newSettings);
                  },
                  onLogout:()=>{
                    api.logout();
                    window.location = '/login';
                  },
                  onChangeSystem:(p)=>{
                    if(p.id === system.id){
                      return;
                    }
                    api.cookie('system', p);
                    window.location.reload();
                  },
                  onUpdateUser: (u)=>{
                    api.cookie('user', u);
                    setUser(u);
                  }
                }}>
                  <App/>
                </AuthContext.Provider>
              : <Auth/>
            }
        </Router>
    </AppContext.Provider>
  );
}